import API from "@/models/API";

export default class DailyLimits {
    constructor(item = {}) {
        this.app_name =item.app_name || ""
        this.store_id =item.store_id || null
        this.offline = item.offline || {
            amount: 0,
            points: 0
        };
        this.online = item.online || {
            amount: 0,
            points: 0
        };
    }

    static getDailyLimits = query =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/stores/daily-limits${query}`
        );

    static updateDailyLimit = (item,store_id) =>
        API.put(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/stores/${store_id}/daily-limits`,
            item
        );

    static updateGlobalDailyLimits = item =>
        API.put(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/stores/daily-limits`,
            item
        );
}
